<template>
  <div class="container">
    <div class="header">{{did.did}}</div>
    <nav class="add-navigation flex flex-wrap">
      <div @click="$router.push({name: 'company-admin-dids'})" class="back-link my-2">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p style="white-space: nowrap">Back to DID</p>
      </div>
      <div class="buttons-wrapper flex-wrap">
        <div @click="$router.push({name: 'company-admin-dids'})" class="secondary-button my-2">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button my-2">
          <primary-button @click.native="editDid">Save DID</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="ml-3">Edit DID</span>
      <div class="row p-3">

          <div class="col-md-4 coi-12">
            <primary-input
                type="text"
                name="phone number"
                v-model="did.did"
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('phone number')}"
                placeholder="Enter phone number"
            />
            <div
                class="help is-danger"
                v-if="errors.has('phone number')"
            >{{ errors.first('phone number') }}</div>
            <div
                class="help is-danger"
                v-if="contactError"
            >{{contactError.phone_number ? contactError.phone_number[0] : null}}</div>
          </div>
          <div class="col-md-4 coi-12">
          <primary-select
              type="text"
              name="location"
              v-model="did.country_uuid"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('location')}"
              placeholder="Location"
          >
            <option
                v-for="(i, k) in countrys"
                :selected="i.country_uuid == did.country_uuid"
                :value="i.country_uuid"
                :key="k"
            >{{i.nice_name ? i.nice_name : i.name}}</option>
          </primary-select>
          <div
              class="help is-danger"
              v-if="contactError"
          >{{contactError.location ? contactError.location : null}}</div>
        </div>
          <div class="col-md-4 coi-12">
          <primary-input
              type="text"
              name="price"
              v-model="did.price"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('price')}"
              placeholder="Enter price"
          />
          <div class="help is-danger" v-if="errors.has('price')">{{ errors.first('price') }}</div>
          <div
              class="help is-danger"
              v-if="contactError"
          >{{contactError.price ? contactError.price[0] : null}}</div>
        </div>
          <div class="col-md-4 coi-12">

              <!-- <primary-select type="text"
                                    name="billing rule"
                                    v-validate="'required'"
                                    v-model="did.price"
                                    :class="{'input': true, 'is-danger': errors.has('billing rule')}"
                                    placeholder="Billing">
                        <option v-for="(i, k) in role"
                            :key="k">{{i}}</option>
                    </primary-select>
                    <div class="help is-danger"
                        v-if="contactError">
                    {{contactError.billing_rule ? contactError.billing_rule : null}}
              </div>-->
              <div class="amount">{{ amount }}</div>


              <primary-select
                type="text"
                name="month"
                v-model="selected"
                :class="{'input': true, 'is-danger': errors.has('month')}"
                placeholder="Month"
              >
                <option v-for="(i, k) in month" :key="k">{{i}}</option>
              </primary-select>
              <div
                class="help is-danger"
                v-if="contactError"
              >{{contactError.month ? contactError.month : null}}</div>

          </div>
          <div class="col-md-4 coi-12">
       <primary-select
           type="text"
           name="company"
           v-validate="'required'"
           v-model="did.company_uuid"
           :class="{'input': true, 'is-danger': errors.has('company')}"
           placeholder="Company Inc."
       >
         <option
             :value="i.company_uuid"
             :selected="i.company_uuid == did.company_uuid"
             v-for="(i, k) in allcompanies"
             :key="k"
         >{{i.company_name}}</option>
       </primary-select>
       <div
           class="help is-danger"
           v-if="contactError"
       >{{contactError.company ? contactError.company : null}}</div>

     </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  data: () => ({
    contactError: null,
    month: ["per hour", "per day", "per month"],
    role: ["per hour", "per day", "per month"],
    contact: null,
    newDid: {
      price: null,
      did: null,
      country_uuid: null,
      company_uuid: null,
    },
    did: [],
    allcompanies: [],
    countrys: [],
    selected: null,
    amount: null,
  }),
  watch: {
    selected: function () {
      if (!this.did.using) {
        this.amount = "";
      } else {
        this.amount =
          this.selected === "per month"
            ? this.did.using.max_sms_per_month
            : this.selected === "per day"
            ? this.did.using.max_sms_per_day
            : this.did.using.max_sms_per_hour;
      }
    },
  },
  created() {
    this.getDid();
    this.getAllCompanies();
    this.getCountrys();
  },
  methods: {
    getCountrys() {
      this.$store.dispatch("getCountryList", {}).then(async (res) => {
        this.countrys = res.items;
      });
    },
    getAllCompanies() {
      this.$store
        .dispatch("GetCompanyList", {
          page: this.Page,
          search: this.SearchCompany,
        })
        .then((res) => {
          console.log("res111--->", res);
          this.allcompanies = res.items; // .map(this.transformCompanies);
        });
    },
    getDid() {
      this.$store
        .dispatch("GetSearchedDid", this.$route.params.id)
        .then((res) => {
          console.log("res GetSearchedDid--->", res);
          this.did = res;
        });
    },
    editDid() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.newDid.country_uuid = this.did.country_uuid;
          this.newDid.company_uuid = this.did.company_uuid;
          this.newDid.did = this.did.did;
          this.newDid.price = this.did.price;
          this.$store
            .dispatch("EditDid", {
              did: this.$route.params.id,
              newDid: this.newDid,
            })
            .then(() => {
              this.$snotify.success("DID have beed edited.", {
                timeout: 6000,
              });
              this.$router.push({ name: "company-admin-dids" });
            })
            .catch((err) => {
              if (err.errors) {
                this.contactError = err.errors[0].contact
                  ? err.errors[0].contact
                  : null;
                setTimeout(() => {
                  this.contactError = null;
                }, 6000);
              } else {
                this.$snotify.error(err.error.message, {
                  timeout: 6000,
                });
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" >
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .header {
    padding: 15px 0;
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 100%;
    background-color: #ffffff;

    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 0;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        padding-left: 0;
        .input {
          margin-bottom: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "" Helvetica Neue "";
          font-size: 12px;
          font-weight: 300;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .amount {
          text-align: center;
          font-size: 24px;
          margin-top: 25px;
        }
      }
      .month {
        padding-right: 0;
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 359px) {

  .secondary-button{
    width: 110px!important;
  }
}
.row .input{
  margin-bottom: 20px;
}
</style>

